import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    list: [],
    item: {},
    filter: {
      word: '',
      list: []
    }
  },
  mutations: {
    initFilter (state) {
      state.filter.word = ''
      state.filter.list = []
    }
  },
  actions: {
    setListData ({ state }, data) {
      state.list = data
    },
    async getReservation ({ state }, space) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-reservation',
          func: 'get-reservation-property-info',
          id: store.state.authentication.requestId,
          ...space && {
            property: space
          }
        })
        const result = space
          ? res.data.message.find(x => x.property === space).payload
          : res.data.message
        return result
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setReservation ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-reservation',
          func: 'update-reservation-property-info',
          id: store.state.authentication.requestId,
          property: data.property,
          payload: data.payload
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async delReservation ({ state }, properties) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-reservation',
          func: 'delete-reservation-property-info',
          id: store.state.authentication.requestId,
          property: properties
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    setReservationListData ({ state, dispatch }) {
      dispatch('getReservation').then(res => {
        const data = res || []
        state.list = data.map(x => {
          return {
            id: x.property,
            title: x.payload.space,
            updateat: x.updateat
          }
        })
        return true
      }).catch((ex) => {
        // alert(ex)
        console.log(ex)
        return false
      })
    }
  },
  getters: {
    list: state => state.list
  }
}
